import { render, staticRenderFns } from "./ech-alert.vue?vue&type=template&id=5f78fa99&"
import script from "./ech-alert.vue?vue&type=script&lang=js&"
export * from "./ech-alert.vue?vue&type=script&lang=js&"
import style0 from "./ech-alert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports